"use strict";

var _slicedToArray = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Canvas = void 0;

var Utils_1 = require("../Utils");

var Utils_2 = require("../Utils");

var Canvas =
/*#__PURE__*/
function () {
  function Canvas(container) {
    _classCallCheck(this, Canvas);

    this.container = container;
    this.size = {
      height: 0,
      width: 0
    };
    this.context = null;
    this.generatedCanvas = false;
  }

  _createClass(Canvas, [{
    key: "init",
    value: function init() {
      this.resize();
      this.initStyle();
      this.initCover();
      this.initTrail();
      this.initBackground();
      this.paint();
    }
  }, {
    key: "loadCanvas",
    value: function loadCanvas(canvas, generatedCanvas) {
      var _a;

      if (!canvas.className) {
        canvas.className = Utils_1.Constants.canvasClass;
      }

      if (this.generatedCanvas) {
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
      }

      this.generatedCanvas = generatedCanvas !== null && generatedCanvas !== void 0 ? generatedCanvas : this.generatedCanvas;
      this.element = canvas;
      this.originalStyle = (0, Utils_1.deepExtend)({}, this.element.style);
      this.size.height = canvas.offsetHeight;
      this.size.width = canvas.offsetWidth;
      this.context = this.element.getContext("2d");
      this.container.retina.init();
      this.initBackground();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this = this;

      var _a;

      if (this.generatedCanvas) {
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
      }

      this.draw(function (ctx) {
        (0, Utils_2.clear)(ctx, _this.size);
      });
    }
  }, {
    key: "paint",
    value: function paint() {
      var _this2 = this;

      var options = this.container.actualOptions;
      this.draw(function (ctx) {
        if (options.backgroundMask.enable && options.backgroundMask.cover && _this2.coverColor) {
          (0, Utils_2.clear)(ctx, _this2.size);

          _this2.paintBase((0, Utils_1.getStyleFromRgb)(_this2.coverColor, _this2.coverColor.a));
        } else {
          _this2.paintBase();
        }
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this3 = this;

      var options = this.container.actualOptions;
      var trail = options.particles.move.trail;

      if (options.backgroundMask.enable) {
        this.paint();
      } else if (trail.enable && trail.length > 0 && this.trailFillColor) {
        this.paintBase((0, Utils_1.getStyleFromRgb)(this.trailFillColor, 1 / trail.length));
      } else {
        this.draw(function (ctx) {
          (0, Utils_2.clear)(ctx, _this3.size);
        });
      }
    }
  }, {
    key: "windowResize",
    value: function windowResize() {
      var _a;

      if (!this.element) {
        return;
      }

      var container = this.container;
      this.resize();

      if (((_a = this.resizeFactor) === null || _a === void 0 ? void 0 : _a.width) === 1 && this.resizeFactor.height === 1) {
        delete this.resizeFactor;
        return;
      }

      container.updateActualOptions();
      container.particles.setDensity();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = container.plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              plugin = _step$value[1];

          if (plugin.resize !== undefined) {
            plugin.resize();
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "resize",
    value: function resize() {
      if (!this.element) {
        return;
      }

      var container = this.container;
      var pxRatio = container.retina.pixelRatio;
      var size = container.canvas.size;
      var oldSize = {
        width: size.width,
        height: size.height
      };
      size.width = this.element.offsetWidth * pxRatio;
      size.height = this.element.offsetHeight * pxRatio;
      this.element.width = size.width;
      this.element.height = size.height;

      if (this.container.started) {
        this.resizeFactor = {
          width: size.width / oldSize.width,
          height: size.height / oldSize.height
        };
      }
    }
  }, {
    key: "drawConnectLine",
    value: function drawConnectLine(p1, p2) {
      var _this4 = this;

      this.draw(function (ctx) {
        var _a;

        var lineStyle = _this4.lineStyle(p1, p2);

        if (!lineStyle) {
          return;
        }

        var pos1 = p1.getPosition();
        var pos2 = p2.getPosition();
        (0, Utils_1.drawConnectLine)(ctx, (_a = p1.retina.linksWidth) !== null && _a !== void 0 ? _a : _this4.container.retina.linksWidth, lineStyle, pos1, pos2);
      });
    }
  }, {
    key: "drawGrabLine",
    value: function drawGrabLine(particle, lineColor, opacity, mousePos) {
      var container = this.container;
      this.draw(function (ctx) {
        var _a;

        var beginPos = particle.getPosition();
        (0, Utils_1.drawGrabLine)(ctx, (_a = particle.retina.linksWidth) !== null && _a !== void 0 ? _a : container.retina.linksWidth, beginPos, mousePos, lineColor, opacity);
      });
    }
  }, {
    key: "drawParticle",
    value: function drawParticle(particle, delta) {
      var _this5 = this;

      var _a, _b, _c, _d, _e, _f;

      if (particle.spawning || particle.destroyed) {
        return;
      }

      var pfColor = particle.getFillColor();
      var psColor = (_a = particle.getStrokeColor()) !== null && _a !== void 0 ? _a : pfColor;

      if (!pfColor && !psColor) {
        return;
      }

      var _this$getPluginPartic = this.getPluginParticleColors(particle),
          _this$getPluginPartic2 = _slicedToArray(_this$getPluginPartic, 2),
          fColor = _this$getPluginPartic2[0],
          sColor = _this$getPluginPartic2[1];

      var pOptions = particle.options;
      var twinkle = pOptions.twinkle.particles;
      var twinkling = twinkle.enable && Math.random() < twinkle.frequency;

      if (!fColor || !sColor) {
        var twinkleRgb = (0, Utils_1.colorToHsl)(twinkle.color);

        if (!fColor) {
          fColor = twinkling && twinkleRgb !== undefined ? twinkleRgb : pfColor ? pfColor : undefined;
        }

        if (!sColor) {
          sColor = twinkling && twinkleRgb !== undefined ? twinkleRgb : psColor ? psColor : undefined;
        }
      }

      var options = this.container.actualOptions;
      var zIndexOptions = particle.options.zIndex;
      var zOpacityFactor = Math.pow(1 - particle.zIndexFactor, zIndexOptions.opacityRate);
      var radius = particle.getRadius();
      var opacity = twinkling ? twinkle.opacity : (_d = (_b = particle.bubble.opacity) !== null && _b !== void 0 ? _b : (_c = particle.opacity) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : 1;
      var strokeOpacity = (_f = (_e = particle.stroke) === null || _e === void 0 ? void 0 : _e.opacity) !== null && _f !== void 0 ? _f : opacity;
      var zOpacity = opacity * zOpacityFactor;
      var fillColorValue = fColor ? (0, Utils_1.getStyleFromHsl)(fColor, zOpacity) : undefined;

      if (!fillColorValue && !sColor) {
        return;
      }

      this.draw(function (ctx) {
        var zSizeFactor = Math.pow(1 - particle.zIndexFactor, zIndexOptions.sizeRate);
        var zStrokeOpacity = strokeOpacity * zOpacityFactor;
        var strokeColorValue = sColor ? (0, Utils_1.getStyleFromHsl)(sColor, zStrokeOpacity) : fillColorValue;

        if (radius <= 0) {
          return;
        }

        var container = _this5.container;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = container.particles.updaters[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var updater = _step2.value;

            if (updater.beforeDraw) {
              updater.beforeDraw(particle);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        (0, Utils_1.drawParticle)(_this5.container, ctx, particle, delta, fillColorValue, strokeColorValue, options.backgroundMask.enable, options.backgroundMask.composite, radius * zSizeFactor, zOpacity, particle.options.shadow, particle.gradient);
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = container.particles.updaters[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _updater = _step3.value;

            if (_updater.afterDraw) {
              _updater.afterDraw(particle);
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      });
    }
  }, {
    key: "drawPlugin",
    value: function drawPlugin(plugin, delta) {
      this.draw(function (ctx) {
        (0, Utils_1.drawPlugin)(ctx, plugin, delta);
      });
    }
  }, {
    key: "drawParticlePlugin",
    value: function drawParticlePlugin(plugin, particle, delta) {
      this.draw(function (ctx) {
        (0, Utils_1.drawParticlePlugin)(ctx, plugin, particle, delta);
      });
    }
  }, {
    key: "initBackground",
    value: function initBackground() {
      var options = this.container.actualOptions;
      var background = options.background;
      var element = this.element;
      var elementStyle = element === null || element === void 0 ? void 0 : element.style;

      if (!elementStyle) {
        return;
      }

      if (background.color) {
        var color = (0, Utils_1.colorToRgb)(background.color);
        elementStyle.backgroundColor = color ? (0, Utils_1.getStyleFromRgb)(color, background.opacity) : "";
      } else {
        elementStyle.backgroundColor = "";
      }

      elementStyle.backgroundImage = background.image || "";
      elementStyle.backgroundPosition = background.position || "";
      elementStyle.backgroundRepeat = background.repeat || "";
      elementStyle.backgroundSize = background.size || "";
    }
  }, {
    key: "draw",
    value: function draw(cb) {
      if (!this.context) {
        return;
      }

      return cb(this.context);
    }
  }, {
    key: "initCover",
    value: function initCover() {
      var options = this.container.actualOptions;
      var cover = options.backgroundMask.cover;
      var color = cover.color;
      var coverRgb = (0, Utils_1.colorToRgb)(color);

      if (coverRgb) {
        this.coverColor = {
          r: coverRgb.r,
          g: coverRgb.g,
          b: coverRgb.b,
          a: cover.opacity
        };
      }
    }
  }, {
    key: "initTrail",
    value: function initTrail() {
      var options = this.container.actualOptions;
      var trail = options.particles.move.trail;
      var fillColor = (0, Utils_1.colorToRgb)(trail.fillColor);

      if (fillColor) {
        var _trail = options.particles.move.trail;
        this.trailFillColor = {
          r: fillColor.r,
          g: fillColor.g,
          b: fillColor.b,
          a: 1 / _trail.length
        };
      }
    }
  }, {
    key: "getPluginParticleColors",
    value: function getPluginParticleColors(particle) {
      var fColor;
      var sColor;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.container.plugins[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _step4$value = _slicedToArray(_step4.value, 2),
              plugin = _step4$value[1];

          if (!fColor && plugin.particleFillColor) {
            fColor = (0, Utils_1.colorToHsl)(plugin.particleFillColor(particle));
          }

          if (!sColor && plugin.particleStrokeColor) {
            sColor = (0, Utils_1.colorToHsl)(plugin.particleStrokeColor(particle));
          }

          if (fColor && sColor) {
            break;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return [fColor, sColor];
    }
  }, {
    key: "initStyle",
    value: function initStyle() {
      var element = this.element,
          options = this.container.actualOptions;

      if (!element) {
        return;
      }

      var originalStyle = this.originalStyle;

      if (options.fullScreen.enable) {
        this.originalStyle = (0, Utils_1.deepExtend)({}, element.style);
        element.style.position = "fixed";
        element.style.zIndex = options.fullScreen.zIndex.toString(10);
        element.style.top = "0";
        element.style.left = "0";
        element.style.width = "100%";
        element.style.height = "100%";
      } else if (originalStyle) {
        element.style.position = originalStyle.position;
        element.style.zIndex = originalStyle.zIndex;
        element.style.top = originalStyle.top;
        element.style.left = originalStyle.left;
        element.style.width = originalStyle.width;
        element.style.height = originalStyle.height;
      }
    }
  }, {
    key: "paintBase",
    value: function paintBase(baseColor) {
      var _this6 = this;

      this.draw(function (ctx) {
        (0, Utils_1.paintBase)(ctx, _this6.size, baseColor);
      });
    }
  }, {
    key: "lineStyle",
    value: function lineStyle(p1, p2) {
      var _this7 = this;

      return this.draw(function (ctx) {
        var options = _this7.container.actualOptions;
        var connectOptions = options.interactivity.modes.connect;
        return (0, Utils_1.gradient)(ctx, p1, p2, connectOptions.links.opacity);
      });
    }
  }]);

  return Canvas;
}();

exports.Canvas = Canvas;